<template>
<div id="tollbars" style="z-index:222 !important">
     <v-navigation-drawer></v-navigation-drawer>

     <v-app-bar :clipped-right="$vuetify.breakpoint.lgAndUp" height="55" app class="BgToolBar" flat>
          <v-tooltip bottom>
               <template v-slot:activator="{ on }">
                    <v-btn color="transparent title" height="42" width="20" v-on="on" @click="OpenModal">
                         <v-img width="30" :src="require('@/assets/logo.png')"></v-img>
                    </v-btn>
               </template>
               <span>{{ $t('menu') }}</span>
          </v-tooltip>

          <v-tooltip bottom v-for="(item, index) in elements" :key="index">
               <template v-slot:activator="{ on }">
                    <v-btn color="transparent" v-on="on" large @click="openApp(item)">
                         <v-avatar size="35">
                              <img :src="require('@/assets/admin/app/'+item.path)" alt="alt" />
                         </v-avatar>
                    </v-btn>
               </template>
               <span>{{ $t('mainApp') }}</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-menu transition="fab-transition" style="z-index:406 !important" offset-y>
               <template v-slot:activator="{ on }">
                    <v-toolbar-items>
                         <v-btn text v-on="on">
                              <v-badge :content="messages" :value="messages" color="red" overlap>
                                   <v-icon size="30">mdi-bell</v-icon>
                              </v-badge>
                         </v-btn>
                    </v-toolbar-items>
               </template>
               <v-list>
                    <v-list-item  :disabled="messagesRDV == 0" @click="openAp(4)">
                         <v-badge :content="messagesRDV" :value="messagesRDV" color="green" overlap>
                              <v-list-item-content>{{ $t('envEmail') + " "  }}

                              </v-list-item-content>
                         </v-badge>

                    </v-list-item>
                    <v-list-item  :disabled="message == 0" @click="openAp(6)">
                         <v-badge :content="message" :value="message" color="orange" overlap>
                              <v-list-item-content>{{ $t('msg') + " " }}</v-list-item-content>
                         </v-badge>
                    </v-list-item>
                    <v-list-item  :disabled="messagesDevi == 0" @click="openAp(5)">
                         <v-badge :content="messagesDevi" :value="messagesDevi" color="blue" overlap>
                              <v-list-item-content>{{ $t('demDevi') + ' ' + $t('devi') + " " }}</v-list-item-content>
                         </v-badge>
                    </v-list-item>
                    <v-list-item  :disabled="messagesQuast == 0" @click="openAp(3)">
                         <v-badge :content="messagesQuast" :value="messagesQuast" color="red" overlap>
                              <v-list-item-content>{{ $t('question') + " " }}</v-list-item-content>
                         </v-badge>
                    </v-list-item>
                    <v-list-item  :disabled="demandeCartFidaliti == 0" @click="openAp(2)">
                         <v-badge :content="demandeCartFidaliti" :value="demandeCartFidaliti" color="red" overlap>
                              <v-list-item-content>{{ $t('cartFidaliti') + " " }}</v-list-item-content>
                         </v-badge>
                    </v-list-item>

               </v-list>
          </v-menu>

          <v-tooltip bottom>
               <template v-slot:activator="{ on }">
                    <v-btn class="mx-4" color="transparent" v-on="on" @click="goToSite">
                         <v-avatar size="40">
                              <v-icon class="mx-0">mdi-web</v-icon>
                         </v-avatar>
                         <!-- <span class="hidden-sm-and-down">{{ $t('website') }}</span> -->
                    </v-btn>
               </template>
               <span>{{ $t('goToWebsite') }}</span>
          </v-tooltip>

          <v-menu transition="fab-transition" style="z-index:406 !important" offset-y>
               <template v-slot:activator="{ on }">
                    <v-toolbar-items>
                         <v-btn text v-on="on">
                              <v-icon class="mx-0">mdi-translate</v-icon>
                              <span class="hidden-sm-and-down">{{ nameLang }}</span>
                         </v-btn>
                    </v-toolbar-items>
               </template>
               <v-list>
                    <v-list-item v-for="(item, index) in langs" :key="index" @click="changLang(item.id)">

                         <v-list-item-content>{{ item.nameC }}</v-list-item-content>
                    </v-list-item>
               </v-list>
          </v-menu>

          <v-menu transition="fab-transition" style="z-index:406 !important" offset-y>
               <template v-slot:activator="{ on }">
                    <v-toolbar-items>
                         <v-btn v-on="on" text>
                              <v-avatar size="30" :class="localLang == 'fr' ? 'ml-4' : 'mr-4'">
                                   <img v-if="getProfile.image == 'avatarFemelle.png' || getProfile.image == 'avatarMale.png'" :src="image ? image : require('@/assets/avatars/' + (getProfile.image ))" />
                                   <img v-else-if="image" :src="image" />
                                   <img v-else :src=" getProfile.n_labo+'/'+ getProfile.image | URL0" />
                              </v-avatar>
                              <span class="hidden-sm-and-down">{{ localLang == "fr" ? getFullNameAr : getFullNameFr }}</span>
                         </v-btn>
                    </v-toolbar-items>
               </template>
               <v-list>
                    <v-list-item v-for="(item,index) in menuProf" :key="index" @click="changAuth(item.id)">
                         <v-list-item-icon>
                              <v-icon>{{ item.icon }}</v-icon>
                         </v-list-item-icon>
                         <v-list-item-content class="">{{ $t(item.text) }}</v-list-item-content>
                    </v-list-item>
               </v-list>
          </v-menu>
     </v-app-bar>

     <v-navigation-drawer dark v-model="drawer" width="" class="pt-0" style="top:56px; width: 480px; max-height: calc(100% - 57px); background-color: rgba(0, 0, 0, 0.52);z-index:1 !important" :clipped="$vuetify.breakpoint.lgAndUp" app :right='localLang == "fr" ? true : false'>
          <v-card class="mx-auto mt-4" color="transparent" tile>
               <v-row align="center" class="fill-height mx-1">
                    <v-col align="center" class="pa-5 " cols="12" lg="4">
                         <input type="file" ref="img" hidden @change="selectImage">
                         <v-card @click="$refs.img.click()" color="transparent" max-height="150" max-width="150">
                              <v-avatar class="profile" size="100">
                                   <img v-if="getProfile.image == 'avatarFemelle.png' || getProfile.image == 'avatarMale.png'" :src="image ? image : require('@/assets/avatars/' + (getProfile.image ))" />
                                   <img v-else-if="image" :src="image" />
                                   <img v-else :src=" getProfile.n_labo+'/'+ getProfile.image | URL0" />
                              </v-avatar>
                         </v-card>
                    </v-col>
                    <v-col cols="8">
                         <v-row>
                              <v-col cols="12" class="pt-1">
                                   <v-text-field outlined dense v-model="form.fullname" hide-details :label="$t('fullname')"></v-text-field>
                              </v-col>
                              <v-col cols="12" class="pt-1">
                                   <v-text-field outlined dense v-model="form.fullnameArab" hide-details :label="$t('fullnameArab')"></v-text-field>
                              </v-col>
                         </v-row>
                    </v-col>
                    <v-col cols="12" class="pt-1">
                         <v-select :items="itemsC" outlined item-text="text" item-value="id" v-model="form.Category" hide-details dense></v-select>
                    </v-col>
                    <v-col cols="6" class="pt-1">
                         <v-text-field outlined dense v-model="form.adress" hide-details :label="$t('adress')"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pt-1">
                         <v-text-field outlined dense v-model="form.email" hide-details :label="$t('email')"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pt-1">
                         <v-text-field outlined dense v-model="form.phone" hide-details :label="$t('phone')"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pt-1">
                         <v-text-field outlined dense v-model="form.fax" hide-details :label="$t('fax')"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6" class="pt-1">
                         <v-autocomplete :items="wilaya" outlined dense clearable v-model="form.wilaya_id" item-text="name_fr" item-value="id" hide-details></v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="6" class="pt-1">
                         <v-autocomplete style="" :items="commune" outlined dense clearable v-model="form.commune_id" item-text="nom" item-value="id" hide-details> </v-autocomplete>
                    </v-col>
                    <v-col cols="12" class="mt-6">
                         <v-text-field outlined dense :value="getProfile.client ? getProfile.client.secret : ''" readonly hide-details :label="$t('secret')"></v-text-field>
                    </v-col>

                    <v-col cols="6" class="pt-1">
                         <v-text-field outlined dense :value="getProfile.dateDebut" readonly hide-details :label="$t('dateInsc')"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pt-1">
                         <v-text-field outlined dense :value="getProfile.dateFin" readonly hide-details :label="$t('dateIExpr')"></v-text-field>
                    </v-col>

                    <v-col cols="12" class="pt-5">
                         <v-divider></v-divider>
                    </v-col>
                    <v-col class="mx-auto pt-2" cols="12">
                         <v-text-field class="mb-4" outlined dense hide-details :label="$t('ancienPass')" v-model="form.ancienPass" clearable></v-text-field>
                         <v-text-field class="mb-4" outlined dense hide-details :label="$t('newPass')" v-model="form.newPass" clearable></v-text-field>
                         <v-text-field class="mb-4" outlined dense hide-details :label="$t('confPassword')" v-model="form.newPass_confirmation" clearable></v-text-field>
                    </v-col>
                    <v-divider></v-divider>

               </v-row>
               <div class="text-center">
                    <v-btn class="mb-8" dark hide-details tile outlined @click="saveChange()">
                         <v-icon :class="localLang == 'fr' ? 'pl-5 pr-3' : 'pl-3 pr-5'" size="25" left>mdi-content-save</v-icon><span :class="localLang == 'fr' ? 'pr-3' : 'pl-3'">{{ $t('update') }}</span>
                    </v-btn>

               </div>
          </v-card>
     </v-navigation-drawer>

     <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
               <v-card-title class="headline">{{ $t('msgLogout') }}</v-card-title>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog = false">{{ $t('non') }}</v-btn>
                    <v-btn color="green darken-1" text @click="logout">{{ $t('oui') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
import {
     components
} from '../../../plugins/compo'
export default {
     components: {
          components,
     },
     data: () => ({
          itemsC: [{
                    id: 1,
                    text: 'Laboratoire d\'anatomie et de cytologie pathologique'
               },
               {
                    id: 2,
                    text: 'Laboratoire d\'analyses de biologie médicale'
               },
               {
                    id: 3,
                    text: 'Centre d\'Imagerie Médicale'
               },
          ],
          image: '',
          drawer: false,
          form: {},
          items: [{
                    title: 'Home',
                    icon: 'dashboard'
               },
               {
                    title: 'About',
                    icon: 'question_answer'
               },
          ],
          menuProf: [{
                    id: 1,
                    text: "editProfil",
                    icon: "mdi-account-edit"
               },
               // {
               //      id: 2,
               //      text: "verCompt",
               //      icon: "mdi-account-lock-outline"
               // },
               {
                    id: 3,
                    text: "deconect",
                    icon: "mdi-location-exit"
               }
          ],
          elements: [],
          apps: [ 
                 {
                    id: 2,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 2,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.result,
                         zIndex: 7,
                         path: 'result.png',
                         active: false,
                         items: [{
                                   id: 1,
                                   title: "resultSite",
                                   icon: "mdi-test-tube",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                              {
                                   id: 2,
                                   title: "cartFidalit",
                                   icon: "mdi-tag-heart",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                              {
                                   id: 3,
                                   title: "demandCartFidaliti",
                                   icon: "mdi-currency-eth",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                         ],
                         text: 'resultSite',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 3,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 3,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.question,
                         zIndex: 7,
                         path: 'question.png',
                         active: false,
                         items: [{
                              id: 1,
                              title: "question",
                              icon: "mdi-semantic-web",
                              active: true,
                              currentComponent: 'question',
                              children: []
                         }, ],
                         text: 'question',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 4,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 4,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.demande,
                         zIndex: 7,
                         path: 'demande.png',
                         active: false,
                         items: [],
                         text: 'demande',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 5,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 5,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.devis,
                         zIndex: 7,
                         path: 'devis.png',
                         active: false,
                         items: [],
                         text: 'devis',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 6,
                    x: 0,
                    y: 0,
                    w: 100,
                    h: 84,
                    app: {
                         id: 6,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.message,
                         zIndex: 7,
                         path: 'message.png',
                         active: false,
                         items: [{
                                   id: 1,
                                   title: "msgRecive",
                                   active: true,
                                   icon: "mdi-message-processing",
                                   currentComponent: 'message',
                                   children: []
                              },
                              {
                                   id: 2,
                                   title: "msgEnvoye",
                                   icon: "mdi-message-draw",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                         ],
                         text: 'msg',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
          ],
          lang: "fr",
          langs: [{
                    id: "ar",
                    name: "ع",
                    nameC: "العربية",
               },
               {
                    id: "fr",
                    name: "fr",
                    nameC: "Français",
               },
          ],
          dialog: false
     }),

     methods: {
          openAp(id) {
              let app = this.apps.find(e => e.id == id)
              console.log('app.app', app.app)
              Fire.$emit('openApp', app.app,true);
          },
          saveChange() { 
               this.form.id = this.getProfile.id
               this.$store.dispatch('changeProfil', {
                    data: JSON.stringify(this.form),
                    img: this.form.image
               }).then((r) => {
                    this.drawer = false
               })
          },
          init() {
               this.form = {
                    id: '',
                    fullname: '',
                    fullnameArab: '',
                    Category: '',
                    phone: '',
                    fax: '',
                    email: '',
                    adress: '',
                    image: '',
                    wilaya_id: '',
                    commune_id: '',
                    ancienPass: '',
                    newPass: '',
                    newPass_confirmation: '',
               }
          },
          selectImage(e) { 
               const file = e.target.files[0]
               this.form.image = file
               this.image = URL.createObjectURL(file)
          },
          openApp(e) { 
               Fire.$emit('openApp', e);
          },
          goToSite() {
               this.$router.push('/vip')
          },
          changAuth(id) {
               if (id == 1) {
                    this.drawer = !this.drawer
               } else if (id == 2) {

               } else {
                    this.dialog = true
               }
          },
          changLang(e) { 
               localStorage.setItem('lang', e)
               Fire.$emit('ChangeLangs', e);
               this.lang = e
          },
          OpenModal() {

          },
          logout() {
               this.$store.dispatch("logout")
               this.$router.push('/')
          },
          closes(e) {
               this.elements.splice(this.elements.indexOf(e), 1);
          },
          getIndexOf(n) {
               let i = -1
               this.elements.find((e, index) => {
                    if (e.id == n) {
                         i = index
                    }
               })
               return i

          }

     },
     computed: {
          messagesRDV() {
               return this.$store.state.demande.filter(e => e.types == 0 && e.isShow == 0).length
          },
          messagesDevi() {
               return this.$store.state.demande.filter(e => e.types == 1 && e.isShow == 0).length
          },
          messagesQuast() {
               return this.$store.state.quastion.filter (e => e.isShow == 0).length
          },
          messages() {
               return this.messagesRDV + this.messagesDevi + this.message + this.messagesQuast + this.demandeCartFidaliti
          },
          message() {
               return this.$store.state.message.filter(e => e.type == 0 && e.isShow == 0).length
          },
          demandeCartFidaliti() {
               return this.$store.state.cartFidaliti.filter(e => e.isDemand == 1).length
          },
          commune() {
               return this.$store.state.commune.filter(e => e.wilaya_id == this.form.wilaya_id)
          },
          getProfile() {
               this.form = {
                    ...this.$store.state.users[0]
               }
               return {
                    ...this.$store.state.users[0]
               }
          },
          getFullName() {
               return localStorage.getItem('')
          },
          nameLang() {
               return this.langs.find(e => e.id == this.lang)['name']
          },
          getFullNameAr() {
               if (this.localLang == 'fr') {
                    return localStorage.getItem('HUDS45DSSKCVZEZFG')
               } else {
                    return localStorage.getItem('LMLVCVPPIDFDdKOSDS')
               }
          },
          getFullNameFr() {
               return localStorage.getItem('LMLVCVPPIDFDdKOSDS')
          }
     },
     created() {
          this.$store.dispatch('getUsers')
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.$store.dispatch('getCartFidaliti')
          this.init()
          this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : localStorage.setItem('lang', 'fr')
          Fire.$on('openApp', (e) => {
               if (this.getIndexOf(e.id) === -1) {
                    this.elements.push(e)
               }
               this.elements.filter(t => {
                    if (t.id == e.id) {
                         return t.active = true
                    } else {
                         return t.active = false
                    }
               })

          })
          Fire.$on("close", e => {
               this.closes(e);
          });
     },
}
</script>

<style scoped>
.BgToolBar {
     background-color: rgba(0, 0, 0, 0.52) !important;
     height: 55px !important;
}

#tollbars .v-text-field.v-text-field--solo .v-input__control {
     min-height: 39px;
     padding: 0;
}

#tollbars * {
     color: whitesmoke
}

.v-toolbar__items>.v-btn {
     min-width: 0px;
     margin: 5px 0px;
     height: 81% !important;
     max-height: none;
}

.v-menu__content--fixed {
     min-width: 50px !important;
     top: 53px !important;
}
</style><style>
.v-autocomplete__content.v-menu__content {
     z-index: 405 !important;
}

.v-menu__content--fixed {
     z-index: 405 !important;
}
</style>
